<template>
  <div id="app">
    <p class="text-centerss">人脸识别</p>
    <face @change="changeBase64"></face>
    <p class="imgbox">
      {{imageSrc}}
    </p>
  </div>
</template>

<script>
import face from './components/face'
export default {
  name: 'App',
  components: {
    face
  },
  data() {
    return {
      imageSrc:''
    }
  },
  methods: {
    changeBase64(src){
      this.imageSrc = src
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.text-center{
  text-align: center;
}
.imgbox{
  width: 300px;
  margin: auto;
  word-break: break-all;
}
</style>
